import React, {Component} from 'react';
import StatusBox from "../StatusBox";
import {connect} from "react-redux";
import {hideModal} from "../../../../actions/nodeEditorPanelActions";
import {clickedNodeAction} from "../../../../actions/clickedNodeActions";
import {PanelLayoutHeader} from "./PanelLayoutHeader";
import {PanelLayoutContentWrapper} from "./PanelLayoutContentWrapper";

class PanelLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "NodeDetail"
        };
        this.changeTab = this.changeTab.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.escKeyUpHandler = this.escKeyUpHandler.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keyup", this.escKeyUpHandler, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.escKeyUpHandler, false);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    handleClose() {
        this.props.hideModal(this.props.node);
    }

    escKeyUpHandler(e) {
        if (e.key === "Escape") {
            this.handleClose();
        }
    }

    render() {
        return (
            <>
                <PanelLayoutHeader handleClose={this.handleClose}>
                    {this.props.headerTabs ? this.props.headerTabs :
                        <>
                            <span data-id="NodeDetail" onClick={this.changeTab}
                                  className={this.state.selectedTab === "NodeDetail" ? "navigation-tab current" : "navigation-tab"}>{this.props.node.title}
                            </span>
                            <span data-id="Status" onClick={this.changeTab}
                                  className={this.state.selectedTab === "Status" ? "navigation-tab current" : "navigation-tab"}>Status
                            </span>
                        </>
                    }
                </PanelLayoutHeader>
                <PanelLayoutContentWrapper className={this.props.className}>
                    {this.props.customTabs
                        ? <>{this.props.children}</>
                        : <>
                            <div
                                className={this.state.selectedTab === "NodeDetail"
                                    ? "gui-editor-content active"
                                    : "gui-editor-content"}
                            >
                                {this.props.children}
                            </div>
                            <div
                                className={this.state.selectedTab === "Status" ? "gui-editor-content active" : "gui-editor-content"}>
                                <StatusBox/>
                            </div>
                        </>
                    }
                </PanelLayoutContentWrapper>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(PanelLayout);